import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const GroupNameStyled = styled.b`
  color: ${colors.neutral[900]};
`;
